import {
	ErrorOutlineOutlined as TotalJobIcon,
	PersonOutlineOutlined as ScheduledIcon,
	PlayArrowOutlined as InProgressIcon,
	TaskAltOutlined as CompletedIcon,
} from '@mui/icons-material'

export const JOB_STATUS = {
	TOTAL_JOBS: 'TOTAL_JOBS',
	SCHEDULED: 'SCHEDULED',
	IN_PROGRESS: 'IN_PROGRESS',
	COMPLETED: 'COMPLETED',
}

export const JOB_STATUS_INFO = {
	TOTAL_JOBS: {
		id: 'totalJobs',
		title: 'Total jobs',
		textColor: '#000000',
		iconColor: '#3498db',
	},
	SCHEDULED: {
		id: 'scheduled',
		title: 'Scheduled',
		textColor: '#e74c3c',
		iconColor: '#e74c3c',
	},
	IN_PROGRESS: {
		id: 'inProgress',
		title: 'In Progress',
		textColor: '#3498db',
		iconColor: '#07bc0c',
	},
	COMPLETED: {
		id: 'completed',
		title: 'Completed',
		textColor: '#07bc0c',
		iconColor: '#07bc0c',
	},
}

export const STATUS_ICONS = {
	totalJobs: TotalJobIcon,
	scheduled: ScheduledIcon,
	inProgress: InProgressIcon,
	completed: CompletedIcon,
}

export const DEFAULT_COLOR = '#000000'

export const HIDDEN_COLUMNS = ['@SourceName', '@OwnerName']

export const DISPLAY_COLUMNS = {
	'@StatusTime': 'Date Status Updated',
}

export const COLUMNS_WITH_DEFAULT_PRESET_VALUE = ['@UserStatus', '@StartTime']
